function priceToString(price) {
  const priceInPounds = (price / 100).toFixed(2)
  return `£${priceInPounds}`
}

export default priceToString
